import { render, staticRenderFns } from "./ProductsFoundersCardItemBody.vue?vue&type=template&id=21c0f3c8&scoped=true&"
import script from "./ProductsFoundersCardItemBody.vue?vue&type=script&lang=js&"
export * from "./ProductsFoundersCardItemBody.vue?vue&type=script&lang=js&"
import style0 from "./ProductsFoundersCardItemBody.vue?vue&type=style&index=0&id=21c0f3c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c0f3c8",
  null
  
)

export default component.exports